import { gql } from "@apollo/client";

export const OUTWARD_TRANSACTION = gql`
query OutwardTransaction {
    getOutwardTransaction {
        status
    }
}
`;
